:host {
  display: flex;
  width: 100%;
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.main-control{
  width: 100%;
  display: flex;
}

.main-control > cr-input {
  flex-grow: 2;
}

.config-control {
  display: none;
  position: absolute;
  top: calc(var(--spacing-08) + 0.25rem);
  width: 100%;
  background-color: var(--color-layer-secondary);
  border-style: solid;
  border-width: 1px;
  border-color: var(--color-border-layer-secondary);
}

.config-control > cr-vstack::part(inner) {
  padding: var(--spacing-05);
}

.predictions {
  display: none;
  position: absolute;
  width: 100%;
  top: calc(var(--spacing-08) + 0.25rem);
  background-color: var(--color-layer-secondary);
  border-style: solid;
  border-width: 1px;
  border-color: var(--color-border-layer-secondary);
}

.expanded {
  display: block;
}

.prediction {
  padding: var(--spacing-03);
  padding-right: var(--spacing-05);
  padding-left: var(--spacing-05);
}

.prediction:hover {
  background-color: var(--color-layer-secondary-hover);
}

.predictions-list-no-results, .predictions-list-progress {
  padding: var(--spacing-05);
  font-style: italic;
  font-size: var(--type-scale-14);
}

.prediction-link {
  text-decoration: none;
  color: var(--color-link-secondary);
}

.highlighted-prediction-link {
  text-decoration: underline;
  color: var(--color-link-primary);
  background-color: var(--color-layer-secondary-hover);
}

.prediction-link:hover {
  text-decoration: underline;
  color: var(--color-link-primary);
}

.predictions-list-error {
  padding: var(--spacing-05);
  font-style: italic;
  font-size: var(--type-scale-12);
  color: var(--color-text-error);
}

